import React from 'react'
import PropTypes from 'prop-types'
import {
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Grid,
    GridItem,
    Text,
    Box,
    Flex
} from '@chakra-ui/react'
import {PlusIcon, MinusIcon, SecurePaymentsIcon} from '../../../components/custom-icons'
import {Component} from '@salesforce/commerce-sdk-react/components'

/**
 * PDC Cart Secure Payments component
 * @param {string} title - Title
 * @param {string} message - Message
 * @param {object} regions - Regions
 * @returns {JSX.Element} - PDC Anchors Block component
 */
export const PDCSecurePayments = ({title, message, regions}) => {
    let components = []
    if (regions) {
        components = regions[0].components || []
    }

    return (
        <AccordionItem mt="-1px">
            {({isExpanded}) => (
                <>
                    <AccordionButton py="24px" px="16px">
                        <Flex justifyContent={'space-between'} w="full" alignItems="center">
                            <Flex alignItems={'center'}>
                                <SecurePaymentsIcon boxSize="32px" />
                                <Text
                                    as="span"
                                    align="left"
                                    variant="eyeBrowSmall"
                                    textTransform={'uppercase'}
                                    ml="12px"
                                    mr="10px"
                                    role="heading"
                                    aria-level="2"
                                >
                                    {title}
                                </Text>
                            </Flex>
                            {isExpanded ? (
                                <MinusIcon boxSize="12px" />
                            ) : (
                                <PlusIcon boxSize="12px" />
                            )}
                        </Flex>
                    </AccordionButton>
                    <AccordionPanel pb="24px">
                        <Grid
                            as="ul"
                            templateColumns={'repeat(auto-fit, minmax(40px, 1fr))'}
                            columnGap="20px"
                            rowGap="8px"
                            mx="16px"
                            listStyleType={'none'}
                            flexWrap={'wrap'}
                        >
                            {components &&
                                components.length > 0 &&
                                components.map((component, i) => (
                                    <GridItem as="li" key={component.id}>
                                        <Component component={component} />
                                    </GridItem>
                                ))}
                        </Grid>
                        <Box pt="16px">
                            <Text variant={'bodyBase2'} color="darkGray">
                                {message}
                            </Text>
                        </Box>
                    </AccordionPanel>
                </>
            )}
        </AccordionItem>
    )
}

PDCSecurePayments.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.object,
                    id: PropTypes.string,
                    typeId: PropTypes.string
                })
            )
        })
    )
}
